import { FormFieldConfig } from '@shared/components/search-form/search-form.component';
import { TableColumn } from '@shared/components/data-table/data-table.component';
import {
  FormField,
  ActionButton,
} from '@shared/components/add-form/add-form.component';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

// Status options
export const PROVIDER_STATUS_OPTIONS = [
  { label: 'e_invoice.provider.status.active', value: true },
  { label: 'e_invoice.provider.status.inactive', value: false },
];

// Search form config
export const PROVIDER_SEARCH_CONFIG: FormFieldConfig[] = [
  {
    key: 'providerName',
    label: 'e_invoice.provider.search.provider_name',
    type: 'text',
    placeholder: 'e_invoice.provider.search.enter_provider_name',
  },
  {
    key: 'providerCode',
    label: 'e_invoice.provider.search.provider_code',
    type: 'text',
    placeholder: 'e_invoice.provider.search.enter_provider_code',
  },
  {
    key: 'status',
    label: 'e_invoice.provider.search.status',
    type: 'select',
    options: PROVIDER_STATUS_OPTIONS,
    placeholder: 'e_invoice.provider.search.select_status',
    showClear: true,
  },
];

// Table columns config
export const PROVIDER_COLUMNS: TableColumn[] = [
  {
    label: 'e_invoice.provider.table.provider_code',
    prop: 'providerCode',
    width: 150,
    align: 'left',
  },
  {
    label: 'e_invoice.provider.table.provider_name',
    prop: 'providerName',
    width: 180,
    align: 'left',
  },
  {
    label: 'e_invoice.provider.table.note',
    prop: 'note',
    width: 200,
    align: 'left',
  },
  {
    label: 'e_invoice.provider.table.status',
    prop: 'status',
    width: 120,
    align: 'center',
    type: 'custom',
  },
  {
    label: 'e_invoice.provider.table.operations',
    prop: 'actions',
    width: 300,
    align: 'center',
    type: 'actions',
  },
];

// Form config
export interface ProviderFormConfig {
  title: string;
  formFields: FormField[];
  headerActions: ActionButton[];
  listRoute: string;
}

export const PROVIDER_FORM_CONFIG: ProviderFormConfig = {
  title: 'e_invoice.provider.form.title_add',
  formFields: [
    {
      label: 'e_invoice.provider.form.fields.provider_code',
      controlName: 'providerCode',
      type: 'text',
      placeholder: 'e_invoice.provider.form.placeholders.enter_provider_code',
      required: true,
      section: 'e_invoice.provider.form.sections.basic_info',
      validators: [Validators.required],
      errorMessages: {
        required: 'e_invoice.provider.messages.error.provider_code_required',
      },
    },
    {
      label: 'e_invoice.provider.form.fields.provider_name',
      controlName: 'providerName',
      type: 'text',
      placeholder: 'e_invoice.provider.form.placeholders.enter_provider_name',
      required: true,
      section: 'e_invoice.provider.form.sections.basic_info',
      validators: [Validators.required],
      errorMessages: {
        required: 'e_invoice.provider.messages.error.provider_name_required',
      },
    },
    {
      label: 'e_invoice.provider.form.fields.note',
      controlName: 'note',
      type: 'textarea',
      placeholder: 'e_invoice.provider.form.placeholders.enter_note',
      required: false,
      section: 'e_invoice.provider.form.sections.basic_info',
      validators: [],
      errorMessages: {},
    },
    {
      label: 'e_invoice.provider.form.fields.status',
      controlName: 'status',
      type: 'checkbox',
      section: 'e_invoice.provider.form.sections.basic_info',
      defaultValue: true,
      validators: [],
      errorMessages: {},
    },
  ],
  headerActions: [
    {
      label: 'common.actions.cancel',
      action: 'cancel',
      severity: 'secondary',
      outlined: true,
    },
    {
      label: 'common.actions.save',
      action: 'save',
      severity: 'info',
    },
  ],
  listRoute: '/configuration/e-invoice/provider',
};

// Status helpers
export function getStatusSeverity(
  status: boolean,
): 'success' | 'warning' | 'danger' | 'secondary' {
  return status ? 'success' : 'secondary';
}

export function getStatusDisplayText(
  status: boolean,
  translateService: TranslateService,
): string {
  return status
    ? translateService.instant('e_invoice.provider.status.active')
    : translateService.instant('e_invoice.provider.status.inactive');
}
